import { render, staticRenderFns } from "./wxLogin.vue.js?vue&type=template&id=bc834c5a&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./wxLogin.vue?vue&type=template&id=bc834c5a&scoped=true"
import script from "./wxLogin.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./wxLogin.vue?vue&type=script&lang=js"
export * from "./wxLogin.vue.js?vue&type=script&lang=js!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./wxLogin.vue?vue&type=script&lang=js"
import style0 from "./wxLogin.vue.css?vue&type=style&index=0&id=bc834c5a&scoped=true&lang=css!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./wxLogin.vue?vue&type=style&index=0&id=bc834c5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc834c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc834c5a')) {
      api.createRecord('bc834c5a', component.options)
    } else {
      api.reload('bc834c5a', component.options)
    }
    module.hot.accept("./wxLogin.vue.js?vue&type=template&id=bc834c5a&scoped=true!=!../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./wxLogin.vue?vue&type=template&id=bc834c5a&scoped=true", function () {
      api.rerender('bc834c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crmWxLogin/wxLogin.vue"
export default component.exports